export default __webpack_public_path__ + "static/media/logo.280ed24d.png";